// 新协议
function kkmhhybrid_check_app_status(opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "check_app_status",
    },
    param: {
      apps: opt.apps
    },
    on:false,
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function kkmh_checkAppStatus(opt) {
  if (window.checkAppStatusCallbackId === undefined) {
    window.checkAppStatusCallbackId = 0
  } else {
    window.checkAppStatusCallbackId++
  }
  var cb = 'checkAppStatusCallback' + window.checkAppStatusCallbackId;
  var callback = opt.callback ? opt.callback : function () {};
  window[cb] = function (res) {
    var params = {
      code: 200,
      data: {
        appStatusList: JSON.parse(res)
      },
      message: "ok"
    }
    callback(params);
    delete window[cb]
  }
  window.kkmh && window.kkmh.checkAppStatus(JSON.stringify({
    apps: opt.apps,
    callBack: cb
  }));
}


/**
 * 获取所有文件下载状态 (游戏分发)<br>
 * kkmh.checkAppStatus，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387275}<br>
 * kkmhhybrid://check_app_status，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=286458042}<br>
 * @param {Object} opt 参数对象
 * @param {Object[]} opt.apps 游戏对象列表
 * @param {String} opt.apps[].appId 游戏id
 * @param {String} opt.apps[].pName 游戏包名
 * @param {String} opt.apps[].versionCode 游戏版本号
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function check_app_status(opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,582000);
  if (allow) {
    // 调用新协议
    kkmhhybrid_check_app_status(opt);
  } else {
    // 调用旧协议
    kkmh_checkAppStatus(opt);
  }
}

export default check_app_status;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/check_app_status/index.js